module.exports = __webpack_public_path__ + "img/26.1a48d4f4.svg";